import React from "react";
import {
  FiClipboard, FiClock, FiBarChart2, FiSearch, FiHelpCircle,
  FiBell, FiMail, FiTarget, FiFileText, FiTrendingUp,
} from "react-icons/fi";

const QUICK_ACTIONS = [
  { label: "My Workload", command: "What's on my plate today?", icon: FiClipboard },
  { label: "Alerts", command: "Show me my smart alerts. What needs my attention?", icon: FiBell },
  { label: "My KPIs", command: "Show my KPI dashboard with key performance metrics.", icon: FiBarChart2 },
  { label: "Standup", command: "Generate my standup", icon: FiClock },
  { label: "Trends", command: "Lead conversion trend this quarter", icon: FiTrendingUp },
  { label: "Daily Report", command: "Generate my daily summary report", icon: FiFileText },
  { label: "Sales Tips", command: "Give me sales guidance for my pipeline", icon: FiTarget },
  { label: "Draft Email", command: "Draft an email about ", icon: FiMail },
  { label: "Playbook", command: "Search playbook for ", icon: FiSearch },
  { label: "Help", command: "help", icon: FiHelpCircle },
];

const BotQuickActions = ({ onSelect }) => {
  return (
    <div className="bot-quick-actions">
      {QUICK_ACTIONS.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.label}
            type="button"
            className="bot-quick-chip"
            onClick={() => onSelect(action.command)}
          >
            <Icon size={13} />
            <span>{action.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default BotQuickActions;
